<template>
  <base-text-field
    :value="value"
    :label="label"
    :placeholder="placeholder"
    @input="handleInput($event)"
    v-currency="computedInputOptions"
    :rules="computedRules"
    :required="required"
    :disabled="disabled"
    ref="input"
  >
    <template #prefix>
      USD
    </template>
  </base-text-field>
</template>

<script>
import BaseTextField from "@/components/base/BaseTextField";
import { CurrencyDirective, parse, setValue } from "vue-currency-input";

export default {
  components: {
    BaseTextField,
  },
  directives: {
    currency: CurrencyDirective,
  },
  props: {
    value: [String, Number],
    label: String,
    placeholder: String,
    precision: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    required: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedInputOptions() {
      const isDollarMode = this.precision === 0;

      return {
        currency: "USD",
        autoDecimalMode: !isDollarMode,
        distractionFree: false,
        valueAsInteger: !isDollarMode, // When true, emits cents
        precision: {
          minimumFractionDigits: isDollarMode ? 0 : 2,
          maximumFractionDigits: isDollarMode ? 0 : 2,
        },
      };
    },

    computedRules() {
      const isDollarMode = this.precision === 0;
      const baseRules = this.rules || [];

      const minMaxRule = (v) => {
        const parsed = parse(v, this.computedInputOptions);
        if (parsed == null || isNaN(parsed)) return true;

        const value = isDollarMode ? parsed : parsed / 100;

        if (this.min != null && value < this.min) {
          return `Minimum allowed amount is $${this.min}`;
        }

        if (this.max != null && value > this.max) {
          return `Maximum allowed amount is $${this.max}`;
        }

        //check if value is not a float
        if (isDollarMode && !Number.isInteger(value)) {
          return "Value must be a whole number";
        }

        return true;
      };

      return [...baseRules, minMaxRule];
    },
  },
  methods: {
    handleInput(event) {
      const parsed = parse(event, this.computedInputOptions);
      this.$emit("input", event); // formatted string
      this.$emit("update:intValue", parsed); // raw number (maybe cents if valueAsInteger true)
    },
  },
  watch: {
    value(newValue) {
      if (typeof newValue === "number" && this.$refs.input) {
        setValue(this.$refs.input, newValue);
      }
    },
  },
};
</script>
